import gql from 'graphql-tag'
import client from '@stores/apollo'
import { IAssetVersion, CreateFloorAssetsVersionInput } from '@api'
import { AssetFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

type IPayload = {
  createFloorAssetsVersion: {
    floorAssetsVersion: IAssetVersion
  }
}

const mutateHandler = handleFetchResult<IPayload, IAssetVersion>({
  handler: (data) => data.createFloorAssetsVersion.floorAssetsVersion,
  name: 'Floor Asset',
})

export default function create(input: CreateFloorAssetsVersionInput): Promise<IAssetVersion> {
  return client.gql.mutate({ mutation, variables: { input } }).then(mutateHandler)
}

const mutation = gql`
  mutation createFloorAsset($input: CreateFloorAssetsVersionInput!) {
    createFloorAssetsVersion(input: $input) {
      floorAssetsVersion {
        id
        mapH
        mapW
        autocad {
          ...AssetFragment
        }
        background {
          ...AssetFragment
        }
      }
    }
  }
  ${AssetFragment}
`
